const radii = {
  none: 0,
  sm: 2,
  md: 4,
  lg: 8,
  full: 9999,
};

export type IRadii = typeof radii;

export default radii;
